import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 170px 140px 170px 120px 32px;
  grid-gap: 16px;
  padding: 0 16px;
  background: #f5f7fb;
  border-radius: 8px;
  height: 50px;
  cursor: pointer;

  & + & {
    margin-top: 12px;
  }
`;

export const Cell = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #474d66;
`;

export const Text = styled.div`
  color: #474d66;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Empty = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-style: italic;
`;

export const Iconleft = styled.div`
  height: 20px;
`;
